module.exports = __webpack_public_path__ + "img/smart_control.bd58456e.jpg";